import { render, staticRenderFns } from "./AspDisplaySettings.vue?vue&type=template&id=661b6829&scoped=true"
import script from "./AspDisplaySettings.vue?vue&type=script&lang=js"
export * from "./AspDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./AspDisplaySettings.vue?vue&type=style&index=0&id=661b6829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b6829",
  null
  
)

export default component.exports